// extracted by mini-css-extract-plugin
export default {"input":"Oba-z","button":"Pba-z","selected":"Qba-z","unavailable":"Rba-z","oos":"Sba-z","image":"Tba-z","paperCutDisabledOverlay":"Uba-z"};